import React from "react";

import { Box, Fade, Stack, Typography } from "@mui/material";
import { format } from "date-fns";

import SummaryItem from "../AdvisorLiquidation/SummaryItem/SummaryItem";
import Button from "@src/multiCustodian/components/MUI/Button/Button";
import useClientName from "@src/multiCustodian/hooks/useClientName";
import toUSD from "@src/utils/toUSD";

import styles from "./RaiseCash.module.css";

interface Props {
  onClose: () => void;
  onContinue: () => void;
  accountName: string;
  custodianAccountId: string;
  amount: string;
  isFullLiquidation: boolean;
}

const RaiseCashDetails: React.FC<Props> = ({
  onClose,
  onContinue,
  accountName,
  custodianAccountId,
  amount,
  isFullLiquidation,
}) => {
  const clientName = useClientName();

  return (
    <Fade in>
      <Stack>
        <Typography className={styles.title}>
          Verify details of the request to raise cash
        </Typography>

        <Typography className={styles.description}>
          Once a request to raise cash has been made, Farther will evaluate
          whether there is already sufficient cash in the account. If trading is
          required to raise cash, then a rebalancing proposal will be generated
          the next business day.
        </Typography>

        <Stack sx={{ my: "40px" }} gap="8px">
          <Typography className={styles.details}>
            Request to Raise Cash Details
          </Typography>

          <Box className={styles.detailsSummary}>
            <SummaryItem label="Client" value={clientName?.fullName} />

            <SummaryItem
              label="Account"
              value={`${accountName} (${custodianAccountId})`}
            />

            <SummaryItem
              label="Amount"
              value={`${toUSD(parseFloat(amount))} ${
                isFullLiquidation ? "(Full Liquidation)" : ""
              }`}
            />

            <SummaryItem
              label="Request Date"
              value={format(new Date(), "M/d/yyyy")}
            />
          </Box>
        </Stack>

        <Stack direction="row" gap="16px" alignSelf="flex-end">
          <Button
            variant="outlined"
            buttonType="primary"
            text="Cancel"
            onClick={onClose}
          />

          <Button
            variant="contained"
            buttonType="primary"
            text="Raise Cash"
            onClick={onContinue}
          />
        </Stack>
      </Stack>
    </Fade>
  );
};

export default RaiseCashDetails;
